import { LinearProgress, MuiPickersUtilsProvider, Typography } from '@dls/react-core';
import { StyledBlueHeading, StyledTabPageContainer } from '../../../components/styled/styles';
import DateFnsUtils from '@date-io/date-fns';
import { SubmitHandler } from 'react-hook-form';
import { StudyForm, StudyFormFields } from '../../../components/studies/study-form';
import { useNavigate } from 'react-router-dom';
import React, { ReactNode, useContext, useState } from 'react';
import { StudyPageContext } from '../../../App';
import { Study, updateStudy } from '../../../api/studykit';
import { RoutePaths } from '../../../routes/main-routes';
import { startOfDay, endOfDay } from 'date-fns';
import { Grid } from '@material-ui/core';
import styled from 'styled-components';
import { usePermission } from '../../../context/authorization';
import { format } from 'date-fns';

export const StudyInformation = () => {
  const { study } = useContext(StudyPageContext);
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const canUpdate = usePermission('Study.Update');

  const onSubmit: SubmitHandler<StudyFormFields> = async (data, event) => {
    const startDate = startOfDay(new Date(data.start)).toISOString();
    const endDate = endOfDay(new Date(data.end)).toISOString();
    data = {
      ...data,
      start: startDate,
      end: endDate,
    };
    setIsSubmitting(true);
    await updateStudy(data)
      .then(() => {
        navigate(`/${RoutePaths.Studies}/${data.id}/edit/information`);
      })
      .catch((e: Error) => {
        console.error(e);
      })
      .finally(() => setIsSubmitting(false));
  };

  return (
    <StyledTabPageContainer>
      {isSubmitting && <LinearProgress variant={'indeterminate'} />}
      <StyledBlueHeading variant="h2">Study details</StyledBlueHeading>
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        {canUpdate ? (
          <StudyForm
            onSubmit={onSubmit}
            onCancel={() => navigate('/')}
            submitButtonText={'Save'}
            study={study}
          />
        ) : (
          <ReadonlyStudyInformation study={study} />
        )}
      </MuiPickersUtilsProvider>
    </StyledTabPageContainer>
  );
};

const StyledFormItem = styled(Typography)`
  display: flex;
  flex-direction: column;
  row-gap: 8px;
`;

const GridFormElement = ({ label, children }: { label: string; children: ReactNode }) => (
  <Grid item xs={12} md={6}>
    <StyledFormItem>
      <Typography weight="bold">{label}</Typography>
      {children}
    </StyledFormItem>
  </Grid>
);

export const ReadonlyStudyInformation = ({ study }: { study: Study }) => {
  return (
    <Grid container spacing={3}>
      <GridFormElement label={'Name'}>{study.name}</GridFormElement>
      <GridFormElement label={'Organization'}>{study.organization}</GridFormElement>
      <GridFormElement label={'Start date'}>
        {format(new Date(study.start), 'dd-MM-yyyy')}
      </GridFormElement>
      <GridFormElement label={'End date'}>
        {format(new Date(study.start), 'dd-MM-yyyy')}
      </GridFormElement>
      <GridFormElement label={'Blinded?'}>{study.blinded ? 'Yes' : 'No'}</GridFormElement>
    </Grid>
  );
};
